import { render, staticRenderFns } from "./other-info.vue?vue&type=template&id=cb1f960e&scoped=true&"
import script from "./other-info.vue?vue&type=script&lang=js&"
export * from "./other-info.vue?vue&type=script&lang=js&"
import style0 from "./other-info.vue?vue&type=style&index=0&id=cb1f960e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1f960e",
  null
  
)

export default component.exports